import ReactGA from "react-ga4";

export const initGA = () => {
  ReactGA.initialize("G-C5M6P4WN11"); // Replace with your Measurement ID
};

export const trackPageView = (url) => {
  ReactGA.send({ hitType: "pageview", page: url });
};